import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    data: { seoKey: 'home' },
    loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'produit',
    children: [
      {
        path: '',
        data: { seoKey: 'produit_overview' },
        loadComponent: () =>
          import('./pages/produit/produit-overview.component').then(
            (m) => m.ProduitOverviewComponent,
          ),
      },
      {
        path: 'core',
        children: [
          {
            path: '',
            data: { seoKey: 'core_overview' },
            loadComponent: () =>
              import('./pages/core/core-overview.component').then((m) => m.CoreOverviewComponent),
          },
          /* Legacy path — kept as a redirect so old links / crawlers stay valid. */
          {
            path: 'tirer',
            redirectTo: 'print-run/first-print-run',
            pathMatch: 'full',
          },
          {
            path: 'print-run',
            children: [
              {
                path: '',
                data: { seoKey: 'module_print_run' },
                loadComponent: () =>
                  import('./pages/module-print-run/module-print-run.component').then(
                    (m) => m.ModulePrintRunComponent,
                  ),
              },
              {
                path: 'first-print-run',
                data: { seoKey: 'module_tirer' },
                loadComponent: () =>
                  import('./pages/module-tirer/module-tirer.component').then(
                    (m) => m.ModuleTirerComponent,
                  ),
              },
              {
                path: 'reprint',
                data: { seoKey: 'module_reimpression' },
                loadComponent: () =>
                  import('./pages/module-reimpression/module-reimpression.component').then(
                    (m) => m.ModuleReimpressionComponent,
                  ),
              },
            ],
          },
          {
            path: 'ventiler',
            data: { seoKey: 'module_ventiler' },
            loadComponent: () =>
              import('./pages/module-ventiler/module-ventiler.component').then(
                (m) => m.ModuleVentilerComponent,
              ),
          },
          {
            path: 'prospecter',
            data: { seoKey: 'module_prospecter' },
            loadComponent: () =>
              import('./pages/module-prospecter/module-prospecter.component').then(
                (m) => m.ModuleProspecterComponent,
              ),
          },
          {
            path: 'budgeter',
            data: { seoKey: 'module_budgeter' },
            loadComponent: () =>
              import('./pages/module-budgeter/module-budgeter.component').then(
                (m) => m.ModuleBudgeterComponent,
              ),
          },
        ],
      },
      {
        path: 'bookinsight',
        children: [
          {
            path: '',
            data: { seoKey: 'bookinsight' },
            loadComponent: () =>
              import('./pages/bookinsight/bookinsight.component').then(
                (m) => m.BookinsightComponent,
              ),
          },
          {
            path: 'tarifs',
            data: { seoKey: 'bookinsight_pricing' },
            loadComponent: () =>
              import('./pages/bookinsight-pricing/bookinsight-pricing.component').then(
                (m) => m.BookinsightPricingComponent,
              ),
          },
          {
            path: 'securite',
            data: { seoKey: 'bookinsight_security' },
            loadComponent: () =>
              import('./pages/bookinsight-security/bookinsight-security.component').then(
                (m) => m.BookinsightSecurityComponent,
              ),
          },
          {
            path: 'faq',
            data: { seoKey: 'bookinsight_faq' },
            loadComponent: () =>
              import('./pages/bookinsight-faq/bookinsight-faq.component').then(
                (m) => m.BookinsightFaqComponent,
              ),
          },
        ],
      },
      {
        path: 'codex',
        data: { seoKey: 'codex_overview' },
        loadComponent: () => import('./pages/codex/codex.component').then((m) => m.CodexComponent),
      },
    ],
  },
  {
    path: 'pourquoi',
    data: { seoKey: 'pourquoi_demandsens' },
    loadComponent: () =>
      import('./pages/pourquoi/pourquoi.component').then((m) => m.PourquoiComponent),
  },
  {
    path: 'solutions',
    data: { seoKey: 'solutions' },
    loadComponent: () =>
      import('./pages/solutions/solutions.component').then((m) => m.SolutionsComponent),
  },
  {
    path: 'insights',
    data: { seoKey: 'insights' },
    loadComponent: () =>
      import('./pages/insights/insights.component').then(m => m.InsightsComponent),
  },
  {
    path: 'insights/:slug',
    loadComponent: () =>
      import('./pages/insight-detail/insight-detail.component').then(m => m.InsightDetailComponent),
  },
  {
    path: 'mentions-legales',
    data: { seoKey: 'legal_notice' },
    loadComponent: () =>
      import('./pages/legal-notice/legal-notice.component').then(m => m.LegalNoticeComponent),
  },
  {
    path: 'vision/codex/:client',
    loadComponent: () =>
      import('./pages/codex-vision/codex-vision.component').then(m => m.CodexVisionComponent),
  },
  {
    path: 'admin/pitch-stats',
    loadComponent: () =>
      import('./pages/admin-pitch-stats/admin-pitch-stats.component').then(
        m => m.AdminPitchStatsComponent,
      ),
  },
  {
    path: '**',
    data: { seoKey: 'not_found' },
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent),
  },
];
